import axios from "axios";
import { useMutation } from "react-query";

const API_PATH = "picking/";

export const useGetPickingProductsReportGroupByProducts = () =>
  useMutation((queryString: string) =>
    axios
      .get(`${API_PATH}GetPickingProductsReportGroupByProducts${queryString}`)
      .then((res) => res.data.data)
      .catch((reason) => Promise.reject(reason.response))
  );
